// extracted by mini-css-extract-plugin
export default {"container":"PrivacyPolicy_container__IIorx","brand":"PrivacyPolicy_brand__y-J46","box":"PrivacyPolicy_box__pG6sv"};